import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },

  [mutation.INVOICE_STATUS_GET_STARTED](state, levyCollectionId) {
    state.invoiceStatus.levyCollectionId = levyCollectionId;
    state.invoiceStatus.loading = true;
    state.invoiceStatus.loaded = false;
  },
  [mutation.INVOICE_STATUS_GET_SUCCEEDED](state, data) {
    state.invoiceStatus.data = data;
    state.invoiceStatus.loading = false;
    state.invoiceStatus.loaded = true;
  },
  [mutation.INVOICE_STATUS_GET_FAILED](state) {
    state.invoiceStatus.loading = false;
  },

  [mutation.PAYMENT_STATUS_GET_STARTED](state, levyCollectionId) {
    state.paymentStatus.levyCollectionId = levyCollectionId;
    state.paymentStatus.loading = true;
    state.paymentStatus.loaded = false;
  },
  [mutation.PAYMENT_STATUS_GET_SUCCEEDED](state, data) {
    state.paymentStatus.data = data;
    state.paymentStatus.loading = false;
    state.paymentStatus.loaded = true;
  },
  [mutation.PAYMENT_STATUS_GET_FAILED](state) {
    state.paymentStatus.loading = false;
  },

  [mutation.LEVY_COMPONENTS_GET_STARTED](state, levyCollectionId) {
    state.levyComponents.levyCollectionId = levyCollectionId;
    state.levyComponents.loading = true;
    state.levyComponents.loaded = false;
  },
  [mutation.LEVY_COMPONENTS_GET_SUCCEEDED](state, data) {
    state.levyComponents.data = data;
    state.levyComponents.loading = false;
    state.levyComponents.loaded = true;
  },
  [mutation.LEVY_COMPONENTS_GET_FAILED](state) {
    state.levyComponents.loading = false;
  },

  [mutation.NOTICE_COUNTS_GET_STARTED](state, levyCollectionId) {
    state.noticeCounts.levyCollectionId = levyCollectionId;
    state.noticeCounts.loading = true;
    state.noticeCounts.loaded = false;
  },
  [mutation.NOTICE_COUNTS_GET_SUCCEEDED](state, data) {
    state.noticeCounts.data = data;
    state.noticeCounts.loading = false;
    state.noticeCounts.loaded = true;
  },
  [mutation.NOTICE_COUNTS_GET_FAILED](state) {
    state.noticeCounts.loading = false;
  },

  [mutation.ACTIVITY_FOR_WEEK_GET_STARTED](state, levyCollectionId) {
    state.activityForWeek.levyCollectionId = levyCollectionId;
    state.activityForWeek.loading = true;
    state.activityForWeek.loaded = false;
  },
  [mutation.ACTIVITY_FOR_WEEK_GET_SUCCEEDED](state, data) {
    state.activityForWeek.data = data;
    state.activityForWeek.loading = false;
    state.activityForWeek.loaded = true;
  },
  [mutation.ACTIVITY_FOR_WEEK_GET_FAILED](state) {
    state.activityForWeek.loading = false;
  },

  [mutation.ACTIVITY_FOR_YEAR_GET_STARTED](state, levyCollectionId) {
    state.activityForYear.levyCollectionId = levyCollectionId;
    state.activityForYear.loading = true;
    state.activityForYear.loaded = false;
  },
  [mutation.ACTIVITY_FOR_YEAR_GET_SUCCEEDED](state, data) {
    state.activityForYear.data = data;
    state.activityForYear.loading = false;
    state.activityForYear.loaded = true;
  },
  [mutation.ACTIVITY_FOR_YEAR_GET_FAILED](state) {
    state.activityForYear.loading = false;
  },

  [mutation.PROVIDER_STATUS_GET_STARTED](state, levyCollectionId) {
    state.providerStatus.levyCollectionId = levyCollectionId;
    state.providerStatus.loading = true;
    state.providerStatus.loaded = false;
  },
  [mutation.PROVIDER_STATUS_GET_SUCCEEDED](state, data) {
    state.providerStatus.data = data;
    state.providerStatus.loading = false;
    state.providerStatus.loaded = true;
  },
  [mutation.PROVIDER_STATUS_GET_FAILED](state) {
    state.providerStatus.loading = false;
  },

  [mutation.PROVIDER_LEVY_AMOUNTS_GET_STARTED](state, levyCollectionId) {
    state.providerLevyAmounts.levyCollectionId = levyCollectionId;
    state.providerLevyAmounts.loading = true;
    state.providerLevyAmounts.loaded = false;
  },
  [mutation.PROVIDER_LEVY_AMOUNTS_GET_SUCCEEDED](state, data) {
    state.providerLevyAmounts.data = data;
    state.providerLevyAmounts.loading = false;
    state.providerLevyAmounts.loaded = true;
  },
  [mutation.PROVIDER_LEVY_AMOUNTS_GET_FAILED](state) {
    state.providerLevyAmounts.loading = false;
  }
};
